import React from 'react';
import { Grid } from 'vendors/semantic-ui';
import { ProductQuantityDropdownProps } from './product-quantity-dropdown-type';

import styles from './product-quantity-dropdown-component.module.css';

export const ProductQuantityDropdown: React.FC<ProductQuantityDropdownProps> = ({
    variant,
    onChange,
}: ProductQuantityDropdownProps) => {
    if (variant) {
        const { id, name, price, quantity } = variant;
        return (
            <React.Fragment>
                <div className={styles.container}>
                    <Grid className={`full-width ${styles.noMargin} ${styles.grid}`}>
                        <Grid.Row className={styles.row}>
                            <Grid.Column width={3}>
                                <div className={styles.quantitySelector}>
                                    <button
                                        className={styles.priceBtn}
                                        disabled={quantity === 0}
                                        onClick={() => {
                                            onChange(id, quantity - 1);
                                        }}
                                        type="button"
                                    >
                                        −
                                    </button>
                                    {quantity}

                                    <button
                                        className={styles.priceBtn}
                                        onClick={() => {
                                            onChange(id, quantity + 1);
                                        }}
                                        type="button"
                                    >
                                        +
                                    </button>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={9}>
                                {name && <div className={styles.variantName}>{name}</div>}
                            </Grid.Column>
                            <Grid.Column width={4}>
                                {price && <div className={styles.variantPrice}>{price}€</div>}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
            </React.Fragment>
        );
    }
    return <React.Fragment></React.Fragment>;
};
